"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _constants = require("settings-ui-sdk/SubscriptionDefinitions/constants");

var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.ACTIVE,
  initialValue: true
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.DESCRIPTION,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.NAME,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.PROCESS,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.OPERATION,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.POSITION,
  initialValue: 0
}];
var CreateType = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.createType;
  },
  namespace: 'email',
  objectType: 'CreateType',
  properties: properties
});
var _default = CreateType;
exports.default = _default;
module.exports = exports.default;